/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState || { currentUser: { role: 'EMPTY' } };
  const role = currentUser?.role;
  return {
    manager: ['ADMIN', 'EMPLOYEE', 'DEV'].includes(role || ''),
    empty: role === 'EMPTY',
  };
}
